<div class="main-container">
  <div class="digital-signature" id="signature-pad-container">
    <p class="digital-signature__title">{{ title }}</p>
    <canvas class="signature-pad" id="signature-pad"></canvas>
  </div>
</div>

<div class="digital-signature__cta">
  <button (click)="clearSignature()" class="btn btn--secondary">Annulla firma</button>
  <button (click)="saveSignature()" [disabled]="signaturePadIsEmpty && !cleared" class="btn btn--primary">Salva firma</button>
</div>

